import {
  Content,
  ContentHeader,
  CreateButton,
  Page,
  SupportButton,
} from '@backstage/core-components';
import { ReactNode } from 'react';

type Props = {
  title: string;
  supportTitle?: string;
  themeId?: string;
  createTitle?: string;
  children?: ReactNode;
};

export const ContentPageLayout = ({
  title,
  supportTitle,
  createTitle,
  children,
  themeId,
}: Props) => {
  return (
    <Page themeId={themeId ?? 'home'}>
      <Content>
        <ContentHeader title={title}>
          {createTitle && <CreateButton title={createTitle} />}
          {supportTitle && <SupportButton>{supportTitle}</SupportButton>}
        </ContentHeader>
        {children}
      </Content>
    </Page>
  );
};
